export const navItems = [
  { label: 'Home', href: '#hero' },
  { label: 'About', href: '#lab' },
  { label: 'Local', href: '#philosophy' },
] as const

export const terminalLines = [
  { command: 'whoami', output: 'sekaizato', accent: true },
  { command: 'class', output: 'co-founder · developer' },
  { command: 'function', output: 'building software solutions' },
] as const

export const labItems = [
  { icon: 'headphones', label: 'Currently Playing', value: 'Harder Better Faster Stronger — Daft Punk' },
  { icon: 'flask', label: 'Digital Lab', value: 'Project One Co., Ltd.' },
  { icon: 'terminal', label: 'Workstation', value: 'MacOS ㆍ Linux ㆍ Fedora' },
  
  
  
] as const

export const stackGroups = [
  { label: 'Data Engineering / Cloud', items: ['Python / SQL', 'Data Warehouse', 'Pipeline Orchestration', 'Cloud Serverless'] },
  { label: 'Data Science & Analytics', items: ['Business Intelligence', 'Data Visualization', 'Statistics', 'Machine Learning'] },
  { label: 'Frontend Engineering', items: ['Typescript', 'React/Vite', 'Next.JS', 'Tailwind CSS', 'SHADCN/UI'] },
  { label: 'Backend & Devops', items: ['FastAPI', 'PostgreSQL', 'Cloud Infrastructure', 'Docker', 'CI/CD', 'Local Network'] },
  
] as const

export const footerLinks = ['GitHub', 'LinkedIn', 'Twitter', 'Email'] as const
